module.exports = __webpack_public_path__ + "static/img/titleText.2382902a.png";